import { create } from "zustand";

const useTemplateStore = create((set, get) => ({
  currentTemplate: null,
  sessionTemplates: {}, // Track templates per session/route
  
  setCurrentTemplate: async (template, source = 'default') => {
    set({ currentTemplate: template });
    
    // Persist to storage with source tracking
    try {
      await window.storage.set('selected-template', JSON.stringify({
        template,
        source,
        timestamp: Date.now()
      }));
      
      // Also track in session state
      const { sessionTemplates } = get();
      set({
        sessionTemplates: {
          ...sessionTemplates,
          [source]: template
        }
      });
    } catch (error) {
      console.error('Failed to save template:', error);
    }
  },
  
  // Get template for specific source/route
  getTemplateForSource: (source) => {
    const { sessionTemplates } = get();
    return sessionTemplates[source] || null;
  },
  
  loadTemplate: async (source = 'default') => {
    try {
      const result = await window.storage.get('selected-template');
      if (result && result.value) {
        const data = JSON.parse(result.value);
        const template = data.template || data; // Handle both old and new format
        
        set({ currentTemplate: template });
        
        // Update session templates
        const { sessionTemplates } = get();
        set({
          sessionTemplates: {
            ...sessionTemplates,
            [source]: template
          }
        });
        
        return template;
      }
    } catch (error) {
      console.log('No saved template found:', error);
    }
    return null;
  },
  
  // Load template for specific route and ensure it persists
  loadTemplateForRoute: async (route) => {
    const { sessionTemplates } = get();
    
    // First check if we have it in session
    if (sessionTemplates[route]) {
      set({ currentTemplate: sessionTemplates[route] });
      return sessionTemplates[route];
    }
    
    // Otherwise load from storage
    return get().loadTemplate(route);
  },
  
  // Clear template (useful for testing)
  clearTemplate: async () => {
    set({ currentTemplate: null, sessionTemplates: {} });
    try {
      await window.storage.delete('selected-template');
    } catch (error) {
      console.error('Failed to clear template:', error);
    }
  },
}));

export default useTemplateStore;